import { create } from "zustand";

type AddContactDialogMode = "manual" | "csv" | null;

interface AddContactDialogState {
  mode: AddContactDialogMode;
}

interface AddContactDialogActions {
  openAddContactDialog: (mode: "manual" | "csv") => void;
  closeAddContactDialog: () => void;
}

const initState: AddContactDialogState = {
  mode: null,
};

type AddContactDialogStore = AddContactDialogState & AddContactDialogActions;

export const useAddContactDialogStore = create<AddContactDialogStore>(
  (set) => ({
    ...initState,
    openAddContactDialog: (mode) => set(() => ({ mode })),
    closeAddContactDialog: () => set(() => ({ mode: null })),
  }),
);
